module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "activeMenu": "users"
    }
  }, [_c('v-panel', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "col-sm-12"
  }, [_vm._l((_vm.error), function(err) {
    return (_vm.error && typeof(_vm.error) == 'object') ? _c('div', {
      staticClass: "alert alert-danger alert-dismissable"
    }, [_vm._v("\n          " + _vm._s(err[0]) + "\n        ")]) : _vm._e()
  }), _vm._v(" "), (_vm.error && typeof(_vm.error) == 'string') ? _c('div', {
    staticClass: "alert alert-danger alert-dismissable"
  }, [_vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "alert alert-success alert-dismissable"
  }, [_vm._v(_vm._s(_vm.success))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "back-to-list",
    attrs: {
      "href": "#/account/team"
    }
  }, [_c('i', {
    staticClass: "icon md-chevron-left"
  }), _vm._v(" " + _vm._s(_vm.$t("account.users.detail.back_to_list")))]), _vm._v(" "), _c('form', {
    staticClass: "team-members-form",
    attrs: {
      "method": "post",
      "role": "form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        !_vm.user.id ? _vm.save_user(_vm.user) : _vm.edit_user(_vm.user)
      }
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(!_vm.user.id) ? _c('h3', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.$t("account.users.detail.title")) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.user.id) ? _c('h3', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.user.full_name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-actions"
  }, [_c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("button.save")))]), _vm._v(" "), (_vm.user.id) ? _c('button', {
    staticClass: "btn btn-default waves-effect waves-classic",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.delete_user(_vm.user.id)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("button.delete")) + " ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("account.users.detail.avatar")))]), _vm._v(" "), _c('div', {
    staticClass: "avatar-wrapper text-center"
  }, [(_vm.user.avatar) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteMemberAvatar(_vm.user)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), (_vm.user.avatar) ? _c('img', {
    staticClass: "img-rounder",
    attrs: {
      "src": _vm.user.avatar ? _vm.user.avatar : '',
      "alt": "NO IMAGE",
      "width": "100",
      "height": "100"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "member-avatar",
      "data-plugin": "dropify",
      "data-default-file": "",
      "data-allowed-file-extensions": "jpg png jpeg gif"
    },
    on: {
      "change": _vm.onAvatarChange
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("account.users.detail.information")))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-6 form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "user-first-name"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.first_name")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.first_name),
      expression: "user.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-first-name",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "first_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6 form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "user-last-name"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.last_name")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.last_name),
      expression: "user.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-last-name",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "user-email"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.email")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-email",
      "required": "",
      "disabled": !!_vm.user.id
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.user.id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 change-password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.change_password),
      expression: "change_password"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox",
      "disabled": !_vm.user.id
    },
    domProps: {
      "checked": Array.isArray(_vm.change_password) ? _vm._i(_vm.change_password, null) > -1 : (_vm.change_password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.change_password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.change_password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.change_password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.change_password = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.users.change_password")))])])]) : _vm._e(), _vm._v(" "), ((_vm.user.id && _vm.change_password) || !_vm.user.id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.password")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('v-input-password', {
    attrs: {
      "id": "password",
      "classes": "form-control input-item",
      "error-classes": "text-xs leading-tight text-red-500",
      "placeholder": _vm.$t('input.your_password'),
      "failed-validation-message": "Votre mot de passe doit comporter au moins 8 caractères et contenir au moins un chiffre, une lettre minuscule, une lettre majuscule et un caractère spécial.",
      "validation-regex": "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$",
      "required": ""
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "password2"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.confirm_password")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('v-input-password', {
    attrs: {
      "id": "password2",
      "classes": "form-control input-item",
      "error-classes": "text-xs leading-tight text-red-500",
      "placeholder": _vm.$t('input.confirm_password'),
      "required": ""
    },
    model: {
      value: (_vm.user.password_confirmation),
      callback: function($$v) {
        _vm.$set(_vm.user, "password_confirmation", $$v)
      },
      expression: "user.password_confirmation"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "status"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.users.status")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.active),
      expression: "user.active"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "status",
      "required": "",
      "disabled": !!_vm.user.id
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.users.active")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.users.inactive")))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "team-member-note"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.notes')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.notes),
      expression: "user.notes"
    }],
    staticClass: "form-control my-10",
    attrs: {
      "id": "team-member-note",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.user.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "notes", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.user.id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "user-stripe-account"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('input.select_stripe_account')) + "\n                          ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.stripe_account_id),
      expression: "user.stripe_account_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "user-stripe-account"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "stripe_account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_vm._l((_vm.stripeAccounts), function(stripeAccount) {
    return _c('option', {
      domProps: {
        "value": stripeAccount.id
      }
    }, [_vm._v(_vm._s(stripeAccount.name))])
  }), _vm._v(" "), _c('option', {
    domProps: {
      "value": null
    }
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.user.id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "team-member-billing-info"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.settings.credit_card.title')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.billingInfo),
      expression: "user.billingInfo"
    }],
    staticClass: "form-control my-10",
    attrs: {
      "id": "team-member-billing-info",
      "rows": "6",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.user.billingInfo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "billingInfo", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (!_vm.user.id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "notes"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.description")))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.description),
      expression: "user.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "notes",
      "cols": "30",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.user.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "description", $event.target.value)
      }
    }
  })])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("account.settings.team_section.access_right")) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "bg-white"
  }, [_c('table', {
    staticClass: "table text-center team-member-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("account.settings.team_section.feature_name")))]), _vm._v(" "), _c('th', {
    staticClass: "pull-right m-r-50 access-right-status"
  }, [_vm._v(_vm._s(_vm.$t("account.settings.team_section.actions")))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                          " + _vm._s(_vm.$t("account.settings.team_section.booking_actions")) + "\n                                        ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.booking_actions),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "booking_actions", $$v)
      },
      expression: "userRights.booking_actions"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                          " + _vm._s(_vm.$t("account.settings.team_section.booking_price")) + "\n                                        ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.booking_prices),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "booking_prices", $$v)
      },
      expression: "userRights.booking_prices"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                          " + _vm._s(_vm.$t("account.settings.team_section.rental_owner")) + "\n                                        ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.user.rental_owner),
      callback: function($$v) {
        _vm.$set(_vm.user, "rental_owner", $$v)
      },
      expression: "user.rental_owner"
    }
  })], 1)])])])])])])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.$t("account.settings.team_section.access_features")) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "bg-white"
  }, [_c('table', {
    staticClass: "table text-center team-member-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("account.settings.team_section.feature_name")))]), _vm._v(" "), _c('th', {
    staticClass: "pull-right m-r-50 access-right-status"
  }, [_vm._v(_vm._s(_vm.$t("account.settings.team_section.actions")))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.team_section.calendar")) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15",
    on: {
      "change": function($event) {
        _vm.checkCalendarChanged(_vm.userRights.calendar)
      }
    }
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.calendar),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "calendar", $$v)
      },
      expression: "userRights.calendar"
    }
  })], 1)])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userRights.calendar),
      expression: "userRights.calendar"
    }]
  }, [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.team_section.calendar_planning")) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.calendar_planning),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "calendar_planning", $$v)
      },
      expression: "userRights.calendar_planning"
    }
  })], 1)])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userRights.calendar),
      expression: "userRights.calendar"
    }]
  }, [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.team_section.calendar_daily")) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.calendar_daily),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "calendar_daily", $$v)
      },
      expression: "userRights.calendar_daily"
    }
  })], 1)])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userRights.calendar),
      expression: "userRights.calendar"
    }]
  }, [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.team_section.calendar_weekly")) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.calendar_weekly),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "calendar_weekly", $$v)
      },
      expression: "userRights.calendar_weekly"
    }
  })], 1)])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userRights.calendar),
      expression: "userRights.calendar"
    }]
  }, [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.team_section.calendar_annual")) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.calendar_annual),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "calendar_annual", $$v)
      },
      expression: "userRights.calendar_annual"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.team_section.bookings")) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.bookings),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "bookings", $$v)
      },
      expression: "userRights.bookings"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.team_section.messages")) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.messages),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "messages", $$v)
      },
      expression: "userRights.messages"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.team_section.analytics")) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15",
    on: {
      "change": function($event) {
        _vm.checkAnalyticsChanged(_vm.userRights.analytics)
      }
    }
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.analytics),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "analytics", $$v)
      },
      expression: "userRights.analytics"
    }
  })], 1)])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userRights.analytics),
      expression: "userRights.analytics"
    }]
  }, [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.team_section.analytics_general")) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.analytics_general),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "analytics_general", $$v)
      },
      expression: "userRights.analytics_general"
    }
  })], 1)])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userRights.analytics),
      expression: "userRights.analytics"
    }]
  }, [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.team_section.analytics_reviews")) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.analytics_reviews),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "analytics_reviews", $$v)
      },
      expression: "userRights.analytics_reviews"
    }
  })], 1)])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userRights.analytics),
      expression: "userRights.analytics"
    }]
  }, [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.team_section.analytics_environment")) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.analytics_environment),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "analytics_environment", $$v)
      },
      expression: "userRights.analytics_environment"
    }
  })], 1)])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userRights.analytics),
      expression: "userRights.analytics"
    }]
  }, [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.team_section.analytics_market")) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.analytics_market),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "analytics_market", $$v)
      },
      expression: "userRights.analytics_market"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.team_section.payments")) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.payments),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "payments", $$v)
      },
      expression: "userRights.payments"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.team_section.rentals")) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.rentals),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "rentals", $$v)
      },
      expression: "userRights.rentals"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.team_section.autoactions")) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.autoactions),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "autoactions", $$v)
      },
      expression: "userRights.autoactions"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.team_section.support")) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.userRights.support),
      callback: function($$v) {
        _vm.$set(_vm.userRights, "support", $$v)
      },
      expression: "userRights.support"
    }
  })], 1)])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.$t("account.settings.team_section.access_properties")) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "bg-white"
  }, [_c('table', {
    staticClass: "table text-center team-member-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("input.apartment")))]), _vm._v(" "), _c('th', {
    staticClass: "pull-right m-r-50 access-right-status"
  }, [_vm._v(_vm._s(_vm.$t("account.settings.team_section.actions")))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rentals), function(rental) {
    return (_vm.rentals) ? _c('tr', [_c('td', [_c('div', {
      staticClass: "m-t-15"
    }, [_vm._v("\n                                " + _vm._s(rental.name) + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "auto auto-onOff pull-right m-r-50 m-t-15",
      on: {
        "click": function($event) {
          _vm.changeAccessPropertiesStatus(rental.id, rental.status)
        }
      }
    }, [_c('switches', {
      attrs: {
        "theme": "bulma",
        "color": "blue",
        "type-bold": "false"
      },
      model: {
        value: (rental.status),
        callback: function($$v) {
          _vm.$set(rental, "status", $$v)
        },
        expression: "rental.status"
      }
    })], 1)])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.user.user_rentals), function(userRental) {
    return (_vm.userRentals && _vm.rentals.length == 0) ? _c('tr', [_c('td', [_c('div', {
      staticClass: "m-t-15"
    }, [_vm._v("\n                                " + _vm._s(userRental.rental ? userRental.rental.name : '') + "\n                              ")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "auto auto-onOff pull-right m-r-50 m-t-15",
      on: {
        "click": function($event) {
          _vm.changeAccessPropertiesStatus(userRental.rental_id, userRental.access)
        }
      }
    }, [_c('switches', {
      attrs: {
        "theme": "bulma",
        "color": "blue",
        "type-bold": "false"
      },
      model: {
        value: (userRental.access),
        callback: function($$v) {
          _vm.$set(userRental, "access", $$v)
        },
        expression: "userRental.access"
      }
    })], 1)])]) : _vm._e()
  })], 2)])])])])])])])])], 2)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-341a79f2"}!./src/app/pages/account/users/users.html
// module id = 1358
// module chunks = 0